const initialState = {
    uuid: 1,
    bookings: []
};

const reducer = (state = initialState, action) => {

    if (action.type === "booking/add") {

        const values = action.payload;
        const prevState = structuredClone(state);

        const newBooking = { ...values, bookingId: prevState.uuid };

        const updatedState = { ...prevState, uuid: prevState.uuid + 1, bookings: [...prevState.bookings, newBooking] };

        return updatedState;
    }

    else if (action.type === "booking/remove") {

        const id = action.payload.id;
        const prevState = structuredClone(state);

        const updatedBookings = prevState.bookings.filter((booking) => booking.bookingId !== id);

        const updatedState = { ...prevState, bookings: updatedBookings };

        return updatedState;
    }

    else {
        return state;
    }
};

export default reducer;
